import * as z from "zod"
import { MarkupCategory, FreightService, LineItemType, LineItemAudience } from "@prisma/client"

export const MarkupModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  label: z.string(),
  category: z.nativeEnum(MarkupCategory),
  min_cost: z.number().int(),
  applicable_freight_services: z.nativeEnum(FreightService).array(),
  line_item_types: z.nativeEnum(LineItemType).array(),
  child_itemized_for: z.nativeEnum(LineItemAudience).array(),
  child_excluded_for: z.nativeEnum(LineItemAudience).array(),
  markup_configuration_id: z.number().int(),
})
